/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './medication-medicines.reducer';

export const MedicationMedicinesDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const medicationMedicinesEntity = useAppSelector(state => state.medicationMedicines.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="medicationMedicinesDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.medicationMedicines.detail.title">MedicationMedicines</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.medicationMedicines.id">Id</Translate>
            </span>
          </dt>
          <dd>{medicationMedicinesEntity.id}</dd>
          <dt>
            <span id="tmDate">
              <Translate contentKey="tinyMedicRestApp.medicationMedicines.tmDate">Tm Date</Translate>
            </span>
          </dt>
          <dd>{medicationMedicinesEntity.tmDate}</dd>
          <dt>
            <span id="tmStart">
              <Translate contentKey="tinyMedicRestApp.medicationMedicines.tmStart">Tm Start</Translate>
            </span>
          </dt>
          <dd>{medicationMedicinesEntity.tmStart}</dd>
          <dt>
            <span id="tmEnd">
              <Translate contentKey="tinyMedicRestApp.medicationMedicines.tmEnd">Tm End</Translate>
            </span>
          </dt>
          <dd>{medicationMedicinesEntity.tmEnd}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.medicationMedicines.status">Status</Translate>
            </span>
          </dt>
          <dd>{medicationMedicinesEntity.status ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.medicationMedicines.active">Active</Translate>
            </span>
          </dt>
          <dd>{medicationMedicinesEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.medicationMedicines.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{medicationMedicinesEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.medicationMedicines.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{medicationMedicinesEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.medicationMedicines.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{medicationMedicinesEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.medicationMedicines.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{medicationMedicinesEntity.microSec}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.medicationMedicines.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{medicationMedicinesEntity.glucoUser ? medicationMedicinesEntity.glucoUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.medicationMedicines.medicine">Medicine</Translate>
          </dt>
          <dd>{medicationMedicinesEntity.medicine ? medicationMedicinesEntity.medicine.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.medicationMedicines.scheduleDetail">Schedule Detail</Translate>
          </dt>
          <dd>{medicationMedicinesEntity.scheduleDetail ? medicationMedicinesEntity.scheduleDetail.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/medication-medicines" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/medication-medicines/${medicationMedicinesEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MedicationMedicinesDetail;
